/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { FC, PropsWithChildren, ReactNode } from "react";

import withScrollToTop from "web/Components/Common/withScrollToTop/withScrollToTop";

import BackNavElement from "../BackNavElement";
import { IBackNavElement } from "../BackNavElement/backNavElement";
import classes from "./mobileHeader.scss";
import { PageHeaderPointsLoadErrorBanner } from "../PointsLoadErrorBanner/bannerSlot";

type HeadingTag = "h1" | "h2" | "span";

interface IMobileHeaderBase extends IBackNavElement {
  dataT1?: string;
  rightEl?: ReactNode;
  withPointsBanner?: boolean;
  headingTag?: HeadingTag;
}

export const MobileHeader: FC<PropsWithChildren<IMobileHeaderBase>> = ({
  children,
  dataT1,
  rightEl,
  withPointsBanner = true,
  headingTag = "h1",
  ...restProps
}) => {
  if (!children) return null;

  const rightElement = rightEl && (
    <div className={classes.headerBar__rightEl}>{rightEl}</div>
  );

  const titleElement = React.createElement(
    headingTag,
    { className: classes.headerBar__content },
    children
  );

  return (
    <>
      <header className={classes.headerBar} data-t1={dataT1}>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <BackNavElement {...restProps} />
        <div className={classes.headerBar__wrapper}>
          {titleElement}
          {rightElement}
        </div>
      </header>
      {withPointsBanner && <PageHeaderPointsLoadErrorBanner />}
    </>
  );
};

const HeaderWithScrollToTop = withScrollToTop(MobileHeader);
export default HeaderWithScrollToTop;
